import {
    Grid,
    makeStyles,
    createStyles,
    Theme,
    RadioGroup,
    FormControlLabel,
    Radio,
} from "@material-ui/core";
import React from "react";
import { AnnounceInputs } from "../../../../utils/AnnounceInterfaces";
import { PropertyTextField } from "../PropertyTextField";
import { useTranslation } from "react-i18next";
import { UserContext } from "../../../../contexts/AppContext";
import AutoCompleteSolo from "../../../components/OverridingMaterial/AutoCompleteSolo";
import { PropertyTextFieldMulitline } from "../PropertyTextFieldMulitline";
import { SelectEndornmentNationPolitique } from "./SelectAnulation";
import * as modePayementService from "../../../../Services/modePayementService";
import {
    EPaymentMethod,
    EPaymentMethodCategory,
} from "../../../../utils/enum/PaymentMethod";
import { ECountries } from "../../../../utils/enum/countries";
import { PropertyTextFieldNum } from "../PropertyTextFieldNum";
import PropertySelect from "../PropertySelect";
import { SelectEndornmentNationPolitiqueNoremb } from "./SelectNoremboursable";

const styles = makeStyles((theme: Theme) =>
    createStyles({
        inpuText: {
            marginBottom: 14,
            marginTop: 6,
        },
        inputText: {
            marginBottom: 14,
            marginTop: 6,
            textAlign: "left",
        },
        inputLabel: {
            fontSize: 14,
            fontFamily: "Josefin Sans",
            color: "#000000",
        },
        annuler: {
            lineHeight: "30px",
        },
    })
);

export function StepSix(props: {
    country: any; // Accept the full country object
    values: AnnounceInputs;
    handleChange: (e: any) => void;
    handleChangePaymentMethod: (e: any) => void;
    setPaypalAccount: (e: any) => void;
    setOrangeAccount: (e: any) => void;
    setMtnAccount: (e: any) => void;
    setExpressUnionAccount: (e: any) => void;
    paypalAccount: any;
    orangeAccount: any;
    mtnAccount: any;
    expressUnionAccount: any;
    paymentSelected: any;
    codePhone: any;
    handleOnChange: (e: any, v: any) => void;
    valueGroup?: any;
    handleChangeGroup?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    searchTypeName?: string;
}) {
    const classes = styles();
    const { t } = useTranslation();
    const userContext = React.useContext(UserContext);
    const SearchTypeName = props.searchTypeName;
    const { user } = userContext;
    const [paypalAccounts, setPaypalAccounts] = React.useState<string[]>([]);
    const [orangeAccounts, setOrangeAccounts] = React.useState<string[]>([]);
    const [mtnAccounts, setMtnAccounts] = React.useState<string[]>([]);
    const [, setNexttelAccounts] = React.useState<string[]>([]);
    const [expressUnionAccounts, setExpressUnionAccounts] = React.useState<
        string[]
    >([]);
    const [, setYupAccounts] = React.useState<string[]>([]);

    let tab: any = [];
    for (let i = 0; i <= 30; i++) {
        tab.push({ name: i });
    }
    let tabFree: any = [];
    for (let i = 3; i <= 30; i++) {
        tabFree.push({ name: i });
    }

    React.useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, []);

 
    React.useEffect(() => {
        modePayementService.getUserRModeByUserId(user._id).then((data: any) => {
            if (data) {
                const paypalElements = data.filter(
                    (el: any) => el.mode === EPaymentMethod.Paypal
                );
                paypalElements.push({
                    _id: "null",
                    recepient_email: "Autre compte",
                });
                setPaypalAccounts(
                    paypalElements.map((el: any) => ({
                        id: el._id,
                        name: el.recepient_email,
                    }))
                );

                //Orange
                const orangeElements = data.filter(
                    (el: any) =>
                        el.mode === EPaymentMethodCategory.MobileMoney &&
                        el.mobile_operator === EPaymentMethod.Orange
                );
                orangeElements.push({
                    _id: "orange",
                    mobile_number: "Autre numéro",
                });
                setOrangeAccounts(
                    orangeElements.map((el: any) => {
                        let fieldName = "account_orange";
                        switch (el.mobile_operator) {
                            case EPaymentMethod.Orange:
                                fieldName = "account_orange";
                                break;
                            case EPaymentMethod.Nexttel:
                                fieldName = "account_nexttel";
                                break;
                            case EPaymentMethod.MTN:
                                fieldName = "account_mtn";
                                break;
                            case EPaymentMethod.ExpressUnion:
                                fieldName = "account_express_union";
                                break;
                            case EPaymentMethod.YUP:
                                fieldName = "account_iup";
                                break;
                            default:
                                break;
                        }
                        return {
                            id: el._id,
                            name: el.mobile_number,
                            operator: el.mobile_operator,
                            fieldName: fieldName,
                        };
                    })
                );

                //MTN
                const mtnElements = data.filter(
                    (el: any) =>
                        el.mode === EPaymentMethodCategory.MobileMoney &&
                        el.mobile_operator === EPaymentMethod.MTN
                );
                mtnElements.push({ _id: "mtn", mobile_number: "Autre numéro" });

                setMtnAccounts(
                    mtnElements.map((el: any) => {
                        let fieldName = "account_mtn";
                        return {
                            id: el._id,
                            name: el.mobile_number,
                            operator: el.mobile_operator,
                            fieldName: fieldName,
                        };
                    })
                );

                //NEXTTEL
                const nexttelElements = data.filter(
                    (el: any) =>
                        el.mode === EPaymentMethodCategory.MobileMoney &&
                        el.mobile_operator === EPaymentMethod.Nexttel
                );
                nexttelElements.push({
                    _id: "mtn",
                    mobile_number: "Autre numéro",
                });

                setNexttelAccounts(
                    nexttelElements.map((el: any) => {
                        let fieldName = "account_mtn";
                        return {
                            id: el._id,
                            name: el.mobile_number,
                            operator: el.mobile_operator,
                            fieldName: fieldName,
                        };
                    })
                );

                //EXPRESS UNION
                const expressUnionElements = data.filter(
                    (el: any) =>
                        el.mode === EPaymentMethodCategory.MobileMoney &&
                        el.mobile_operator === EPaymentMethod.ExpressUnion
                );
                expressUnionElements.push({
                    _id: "express_union",
                    mobile_number: "Autre numéro",
                });
                setExpressUnionAccounts(
                    expressUnionElements.map((el: any) => {
                        let fieldName = "account_express_union";
                        return {
                            id: el._id,
                            name: el.mobile_number,
                            operator: el.mobile_operator,
                            fieldName: fieldName,
                        };
                    })
                );

                //YUP
                const yupElements = data.filter(
                    (el: any) =>
                        el.mode === EPaymentMethodCategory.MobileMoney &&
                        el.mobile_operator === EPaymentMethod.YUP
                );
                yupElements.push({ _id: "yup", mobile_number: "Autre numéro" });

                setYupAccounts(
                    yupElements.map((el: any) => {
                        let fieldName = "account_yup";
                        return {
                            id: el._id,
                            name: el.mobile_number,
                            operator: el.mobile_operator,
                            fieldName: fieldName,
                        };
                    })
                );
            }
        });
    }, [user._id]);

    const onChangePaypal = (val: any) => {
        if (val != null) {
            props.setPaypalAccount(val);
            props.handleChange({
                target: {
                    name: "account_paypal",
                    value: val.name === "Autre compte" ? "" : val.name,
                },
            });
        }
    };

    const onChangeOrange = (val: any) => {
        if (val != null) {
            props.setOrangeAccount(val);
            props.handleChange({
                target: {
                    name: "account_orange",
                    value: val.name === "Autre numéro" ? "" : val.name,
                },
            });
        }
    };

    const onChangeMtn = (val: any) => {
        if (val != null) {
            props.setMtnAccount(val);
            props.handleChange({
                target: {
                    name: "account_mtn",
                    value: val.name === "Autre numéro" ? "" : val.name,
                },
            });
        }
    };

    
    const onAddNewPaypalAccount = (e: any) => {
        if (props.paypalAccount.id === "null") {
            props.handleChange({
                target: {
                    name: e.target.name,
                    value: e.target.value,
                },
            });
        } else if (props.paypalAccount.id === undefined) {
            props.handleChange({
                target: {
                    name: e.target.name,
                    value: e.target.value,
                },
            });
        }
    };

    const onAddNewOrangeAccount = (e: any) => {
        if (props.orangeAccount.id === "orange") {
            props.handleChange({
                target: {
                    name: e.target.name,
                    value: e.target.value,
                },
            });
        } else if (props.orangeAccount.id === undefined) {
            props.handleChange({
                target: {
                    name: e.target.name,
                    value: e.target.value,
                },
            });
        }
    };

    const onAddNewMtnAccount = (e: any) => {
        if (props.mtnAccount.id === "mtn") {
            props.handleChange({
                target: {
                    name: e.target.name,
                    value: e.target.value,
                },
            });
        } else if (props.mtnAccount.id === undefined) {
            props.handleChange({
                target: {
                    name: e.target.name,
                    value: e.target.value,
                },
            });
        }
    };

    
    return (
        <Grid container style={{ textAlign: "left" }}>
            <h3>{t("propriete.labels.enregistrer-vos-comptes")}</h3>
            <Grid
                item
                lg={12}
                sm={12}
                xs={12}
                style={{
                    marginBottom: props.paypalAccount.length > 1 ? 0 : 16,
                }}
            >
                <label
                    htmlFor="paypalAccountSel"
                    className={classes.inputLabel}
                >
                    {`${t("label.compte-paypal")} : `}
                </label>
            </Grid>
            {paypalAccounts.length > 1 && !props.values.account_paypal && (
                <Grid item lg={12} sm={12} xs={12} className={classes.inpuText}>
                    <AutoCompleteSolo
                        id="paypalAccountSel"
                        name="account_paypal"
                        selectedValues={props.paypalAccount}
                        values={paypalAccounts}
                        onChangeSelect={onChangePaypal}
                    />
                </Grid>
            )}

            {(props.paypalAccount.id === "null" ||
                paypalAccounts.length <= 1 ||
                props.values.account_paypal) && (
                <Grid item lg={12} sm={12} xs={12}>
                    <PropertyTextField
                        id="paypalAccount"
                        label={`${t("label.entrer-un-autre-compte")} :`}
                        name="account_paypal"
                        value={props.values.account_paypal}
                        handleChange={onAddNewPaypalAccount}
                    />
                </Grid>
            )}

            {props.country?.name === ECountries.Cameroon && (
                <>
                    <Grid
                        item
                        lg={12}
                        sm={12}
                        xs={12}
                        style={{
                            marginBottom: orangeAccounts.length > 1 ? 0 : 16,
                        }}
                    >
                        <label
                            htmlFor="orangeAccountSel"
                            className={classes.inputLabel}
                        >
                            {`${t("label.compte-orange")} :`}
                        </label>
                    </Grid>
                    {orangeAccounts.length > 1 &&
                        !props.values.account_orange && (
                            <Grid
                                item
                                lg={12}
                                sm={12}
                                xs={12}
                                className={classes.inpuText}
                            >
                                <AutoCompleteSolo
                                    id="orangeAccountSel"
                                    name="account_orange"
                                    selectedValues={props.orangeAccount}
                                    values={orangeAccounts}
                                    onChangeSelect={onChangeOrange}
                                />
                            </Grid>
                        )}

                    {(props.orangeAccount.id === "orange" ||
                        orangeAccounts.length <= 1 ||
                        props.values.account_orange) && (
                        <Grid item lg={12} sm={12} xs={12}>
                            <PropertyTextFieldNum
                                id="orangeAccount"
                                codenum={props.codePhone}
                                label={`${t("label.entrer-un-numero")} :`}
                                name="account_orange"
                                value={
                                    props.values.account_orange ===
                                    "Autre numéro"
                                        ? ""
                                        : props.values.account_orange
                                }
                                handleChange={onAddNewOrangeAccount}
                            />
                        </Grid>
                    )}

                    <Grid
                        item
                        lg={12}
                        sm={12}
                        xs={12}
                        style={{
                            marginBottom: mtnAccounts.length > 1 ? 0 : 16,
                        }}
                    >
                        <label
                            htmlFor="mtnAccountSel"
                            className={classes.inputLabel}
                        >
                            {`${t("label.compte-mtn")} : `}
                        </label>
                    </Grid>

                    {mtnAccounts.length > 1 && !props.values.account_mtn && (
                        <Grid
                            item
                            lg={12}
                            sm={12}
                            xs={12}
                            className={classes.inpuText}
                        >
                            <AutoCompleteSolo
                                id="mtnAccountSel"
                                name="account_mtn"
                                selectedValues={props.mtnAccount}
                                values={mtnAccounts}
                                onChangeSelect={onChangeMtn}
                            />
                        </Grid>
                    )}

                    {(props.mtnAccount.id === "mtn" ||
                        mtnAccounts.length <= 1 ||
                        props.values.account_mtn) && (
                        <Grid item lg={12} sm={12} xs={12}>
                            <PropertyTextFieldNum
                                id="mtnAccount"
                                label={`${t("label.entrer-un-numero")} :`}
                                name="account_mtn"
                                codenum={props.codePhone}
                                value={
                                    props.values.account_mtn === "Autre numéro"
                                        ? ""
                                        : props.values.account_mtn
                                }
                                handleChange={onAddNewMtnAccount}
                            />
                        </Grid>
                    )}
                      {/*<Grid
                        item
                        lg={12}
                        sm={12}
                        xs={12}
                        style={{
                            marginBottom: mtnAccounts.length > 1 ? 0 : 16,
                        }}
                    >
                        <label
                            htmlFor="expressUnionAccountSel"
                            className={classes.inputLabel}
                        >
                            {`${t("label.compte-express-union")} : `}
                        </label>
                    </Grid> 

                  
                    {expressUnionAccounts.length > 1 &&
                        !props.values.account_express_union && (
                            <Grid
                                item
                                lg={12}
                                sm={12}
                                xs={12}
                                className={classes.inpuText}
                            >
                                <AutoCompleteSolo
                                    id="expressUnionAccountSel"
                                    name="account_express_union"
                                    selectedValues={props.expressUnionAccount}
                                    values={expressUnionAccounts}
                                    onChangeSelect={onChangeExpressUnion}
                                />
                            </Grid>
                        )}
                    
                    {(props.expressUnionAccount.id === "express_union" ||
                        expressUnionAccounts.length <= 1 ||
                        props.values.account_express_union) && (
                        <Grid item lg={12} sm={12} xs={12}>
                            <PropertyTextFieldNum
                                id="expressUnionAccount"
                                label={`${t("label.entrer-un-numero")} :`}
                                name="account_express_union"
                                codenum={props.codePhone}
                                value={
                                    props.values.account_express_union ===
                                    "Autre numéro"
                                        ? ""
                                        : props.values.account_express_union
                                }
                                handleChange={onAddNewExpressUnionAccount}
                            />
                        </Grid>
                    )}
                    */}
                    <PropertySelect
                        id="favoritePaymentMethod"
                        label={`${t("label.favoritePaymentMethod")} : *`}
                        name="favoritePaymentMethod"
                        value={props.values.favoritePaymentMethod}
                        handleChange={props.handleChange}
                    />
                </>
            )}

        { SearchTypeName !== "rstt" && (
        <>
            <PropertyTextFieldMulitline
                id="cancellationPolicyText"
                label={`${t(`label.conditions-d-annulation`)} :`}
                name="cancellationPolicy"
                value={props.values.cancellationPolicy}
                handleChange={props.handleChange}
                minRows={2}
            />

            <RadioGroup
                row
                aria-label="position"
                value={props.valueGroup}
                onChange={props.handleChangeGroup}
            >
                <FormControlLabel
                    value="remboursable"
                    control={<Radio color="primary" />}
                    label={t("annonce.remborse-titre")}
                    style={{ fontSize: "inherit" }}
                    labelPlacement="end"
                />

                <div>
                    <p className={classes.annuler}>
                        <span style={{ whiteSpace: "nowrap", marginRight: 10 }}>
                            {" "}
                            1- {t("detail-annonce.refundItem11")}{" "}
                        </span>
                        <SelectEndornmentNationPolitique
                            id="country"
                            name="freeRefundDay"
                            values={tabFree}
                            remboursable={props.valueGroup}
                            selectedValue={props.values.freeRefundDay}
                            handleOnChange={props.handleOnChange}
                            isUpdating={false}
                        />
                        <span style={{ marginLeft: 10 }}>
                            {" "}
                            {t("detail-annonce.refundItem12")}.
                        </span>
                    </p>{" "}
                    <br />
                    <p className={classes.annuler}>
                        <span style={{ whiteSpace: "nowrap", marginRight: 10 }}>
                            2- {t("detail-annonce.refundItem21")}
                        </span>
                        {props.values.freeRefundDay}
                        <span style={{ marginLeft: 10 }}>
                            {t("detail-annonce.refundItem22")}
                        </span>
                        <SelectEndornmentNationPolitique
                            id="country"
                            name="penaltyDayFees"
                            values={tab.filter((item: any) => item.name !== 0)}
                            selectedValue={props.values.penaltyDayFees}
                            handleOnChange={props.handleOnChange}
                            remboursable={props.valueGroup}
                            isUpdating={false}
                        />
                        <span style={{ marginLeft: 10 }}>
                            {t("detail-annonce.refundItem23")} .{" "}
                        </span>
                    </p>
                    <br />
                    <p className={classes.annuler}>
                        <span style={{ marginRight: 10 }}>
                            3- {t("detail-annonce.refundItem31")}
                        </span>
                        <SelectEndornmentNationPolitique
                            id="country"
                            name="penaltyDayFeesAfterBookingStarted"
                            values={tab}
                            selectedValue={
                                props.values.penaltyDayFeesAfterBookingStarted
                            }
                            handleOnChange={props.handleOnChange}
                            remboursable={props.valueGroup}
                            isUpdating={false}
                        />
                        <span style={{ marginLeft: 10 }}></span>
                        {t("detail-annonce.refundItem32")}
                    </p>
                </div>
                <FormControlLabel
                    value="noremboursable"
                    control={<Radio color="primary" />}
                    label={t("annonce.option-not-remb")}
                    style={{ fontSize: "inherit" }}
                    labelPlacement="end"
                />
                <div>
                    <p className={classes.annuler}>
                        <span style={{ marginRight: 10 }}>
                            1- {t("annonce.not-remb1")}{" "}
                            <SelectEndornmentNationPolitiqueNoremb
                                id="country"
                                name="notRemboursable1"
                                values={tab}
                                selectedValue={props.values.notRemboursable1}
                                handleOnChange={props.handleOnChange}
                                remboursable={props.valueGroup}
                                isUpdating={false}
                            />
                        </span>
                        <span style={{ marginRight: 10 }}>
                            {t("annonce.not-remb2")}
                        </span>
                    </p>
                    <p className={classes.annuler}>
                        <span style={{ marginRight: 10 }}>
                            2- {t("annonce.not-remb3")}{" "}
                            {props.values.notRemboursable1}
                        </span>
                        <span style={{ marginRight: 10 }}>
                            {t("annonce.not-remb4")}
                        </span>
                    </p>
                </div>
            </RadioGroup>
        </>
    )} 

        </Grid>
    );
}
